import InfoShort from './InfoShort'

export default InfoShort
